// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"ErrorMessage_ErrorMessage__zuLb3"};